import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { switchMap, map, catchError, of } from 'rxjs';
import { PermissionService } from '../services/permission.service';
import {
  fetchPermissionList,
  loadedPermissionList,
  failedPermissionList,
  updatePermissionListFilter,
} from './permission-list.actions';
import { selectPermissionListFilter } from './permission-list.selector';

@Injectable()
export class PermissionListEffect {
  loadPermissionList$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fetchPermissionList),
      switchMap(({ filter }) =>
        this.permissionService.getPermissionList(filter).pipe(
          map(res => {
            if (res.success) {
              return loadedPermissionList({
                dataSource: {
                  totalRecords: res.response.totalRecords,
                  page: res.response.page,
                  count: res.response.count,
                  rawData: res.response.list,
                },
              });
            } else {
              return failedPermissionList();
            }
          }),
          catchError(() => of(failedPermissionList()))
        )
      )
    );
  });

  updateFilter$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(updatePermissionListFilter),
      concatLatestFrom(() => this.store.select(selectPermissionListFilter)),
      switchMap(([action, prevFilter]) =>
        of(fetchPermissionList({ filter: { ...prevFilter, ...action.filter } }))
      )
    );
  });

  constructor(
    private store: Store,
    private readonly actions$: Actions,
    private readonly permissionService: PermissionService
  ) {}
}
